// Authorization Service
import React from "react";
import Wretch from "wretch";
import MainContext from "../context/main-context";
import { quickLogEvent } from "./LogService";
import { token, tokenUrl } from "./ServiceConfig";

class AuthService extends React.Component {
  // List of Functions //
  // login
  // verify
  // logout
  // isAuthenticated
  // isVerified

  login = (username, password) => {
    // First check to make sure you have a value for login and password
    if (username && password) {
      return Wretch(tokenUrl)
        .body(
          "grant_type=password&username=" + username + "&password=" + password
        )
        .headers({ "Content-Type": "application/x-www-form-urlencoded" })
        .post()
        .json((response) => {
          console.log("Auth", response);
          quickLogEvent("Logged In", 1, "User Logged In");
          // this.context.updateValue("isAuthenticated", true);
          return Promise.resolve(response);
        })
        .catch((error) => {
          // error[errorType] (here, json) contains the parsed body
          console.log("LOGIN ERROR: " + error.json);
          return Promise.reject("Failed");
        });
    } else {
      console.log("Login Failed");
      return Promise.reject("Failed");
    }
  };

  verify = (code, remberDevice) => {
    //Get Auth Token
    // const authToken =
    //   sessionStorage.getItem("authToken") !== null
    //     ? sessionStorage.getItem("authToken")
    //     : null;

    remberDevice = remberDevice !== null ? remberDevice : false;

    // const twoStep = {
    //   passcode: code,
    //   remberDevice: remberDevice,
    // };

    // For testing return sucess
    const tempPromise = new Promise((resolve, reject) => {
      if (code !== "") {
        resolve("success");
      } else {
        reject(new Error("rejected"));
      }
    });

    // FOR NOW SET VERIFICATION TOKEN
    sessionStorage.setItem("verifyToken", "1234");

    // Returning temp promise that is always success
    return tempPromise;
  };

  logout = () => {
    console.log("LOGOUT CALLED");

    quickLogEvent("Logged Out", 1, "User Logged Out");

    sessionStorage.removeItem("authToken");
    sessionStorage.removeItem("verifyToken");
    localStorage.clear();
    sessionStorage.clear();
  };

  isAuthenticated = () => {
    const isAuthenticated = token == null ? false : true;
    return isAuthenticated;
  };

  isVerified = () => {
    // Check for Authenication First
    const isAuthenticated = this.isAuthenticated();
    // Check for Verification Token
    // This may change based on what type of object is returned
    const verifyToken =
      sessionStorage.getItem("verifyToken") !== null
        ? sessionStorage.getItem("verifyToken")
        : null;

    // console.log("isVerified called = " + verifyToken);

    return verifyToken != null && isAuthenticated ? true : false;
  };
}

AuthService.contextType = MainContext;
export default AuthService;
